import type { Battery, BatteryLifecycleStatus, BatteryStatusLog } from '../../types';

// Applies a manual lifecycle override on top of a battery. Unlike the drone airworthy
// override (which overwrites the same readiness axis), the battery's auto health `status`
// (ok/aging) and the manual `lifecycleStatus` (in-service/hold/retired) are DIFFERENT
// axes — the override writes `lifecycleStatus` only and never touches `status`. The log
// is read separately from the logs record, mirroring how airworthy reads airworthyLogs.
export const applyBatteryStatus = ({
    battery,
    batteryStatusLogs,
    batteryStatusOverrides
}: {
    battery: Battery;
    batteryStatusLogs: Record<string, BatteryStatusLog>;
    batteryStatusOverrides: Record<string, BatteryLifecycleStatus>;
}): Battery => {
    const override = batteryStatusOverrides[battery.id];

    if (!override) {
        return battery;
    }

    return {
        ...battery,
        lifecycleStatus: override,
        lifecycleStatusLog: batteryStatusLogs[battery.id]
    };
};
